var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"time"}},[_c('div',{class:['state' + _vm.step],attrs:{"id":"time-box"}},[_vm._v(" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }